import { render, staticRenderFns } from "./HistoryAI.vue?vue&type=template&id=3098b014&scoped=true"
import script from "./HistoryAI.vue?vue&type=script&lang=js"
export * from "./HistoryAI.vue?vue&type=script&lang=js"
import style0 from "./HistoryAI.vue?vue&type=style&index=0&id=3098b014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3098b014",
  null
  
)

export default component.exports